import React from 'react';
import { Drawer,
    CircularProgress, 
    TextField, 
    IconButton,
    FormControlLabel,
    Checkbox,
    Tooltip
} from '@material-ui/core/';

import EnhancedTable from "@apricityhealth/web-common-lib/components/EnhancedTable";
import Plan from '@apricityhealth/web-common-lib/components/Plan';
import DataModelView from './DataModelView';

import RefreshIcon from '@material-ui/icons/Refresh';
import WarningIcon from '@material-ui/icons/Warning';
import ValidIcon from '@material-ui/icons/CheckCircle';

import {
    loadDataModels
} from '@apricityhealth/web-common-lib/utils/Services';
import EditableNote from '../components/EditableNote'
import PubSub from 'pubsub-js'

function filterModel(filter, model) {
    if (model.modelId && model.modelId.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
        return true;
    if (model.dataId && model.dataId.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
        return true;
    if (model.name && model.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
        return true;

    return false;
}

export class DataModelsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dependencies: JSON.parse(localStorage.getItem("DataModelsView.dependencies") || 'true'),
            filter: '',
            models: []
        }
    }
    
    componentDidMount() {
        this.token = PubSub.subscribe('PLAN_TOPIC', (msg, data) => {
            if (data.action === 'PlanSelected') {
                this.loadContent();
            }
        });
        this.loadContent();
    }

    componentWillUnmount(){
        PubSub.unsubscribe(this.token);
    }

    loadContent() {
        const self = this;
        let { appContext } = this.props;
        let { dependencies } = this.state;
        this.setState({ progress: <CircularProgress size={20} />, error: null });
        loadDataModels(appContext, { modelId: '*', dependencies }).then((models) => {
            self.setState({ models, progress: null, error: null }, self.onContentLoaded.bind(self));
        }).catch((err) => {
            self.setState({ progress: null, error: err.message });
        });
    }

    onContentLoaded() {
        this.updateFilter();
        this.handleOpen();
    }

    handleOpen() {
        // automatically open the question by ID if provided..
        let parts = window.location.pathname.slice(1).split('/');
        if ( parts.length > 1) {
            window.history.replaceState( null, '',  window.location.href.substring( 0, window.location.href.lastIndexOf('/') ));
            let model = this.state.models.find((e) => e.modelId === parts[1]);
            if ( model )
                this.onOpenModel(model);
        }
    }

    updateFilter() {
        let { filter, models } = this.state;
        if (filter) {
            var filtered = [];
            for (var i = 0; i < models.length; ++i) {
                if (filterModel(filter, models[i]))
                    filtered.push(models[i]);
            }
            this.setState({ filtered });
        }
        else {
            this.setState({ filtered: null });
        }
    }

    onCloseDialog() {
        this.setState({ dialog: null });
        this.loadContent();
        if (this._types)
            this._types.setState({ selected: [] });
    }

    selectModel(s, t) {
        console.log("selectModel:", s, t);
        if (s.length > 0) {
            const model = this.state.filtered ? this.state.filtered[s[0]] : this.state.models[s[0]];
            this.onOpenModel( model );
        }
        else {
            // nothing selected..
            this.setState({ dialog: null });
        }
    }

    onOpenModel(model) {
        let dialog = <Drawer variant="persistent" anchor="right" open={true}>
            <DataModelView appContext={this.props.appContext} model={model} onClose={this.onCloseDialog.bind(this)} />
        </Drawer>;
        this.setState({ dialog });
    }

    createModel() {
        console.log("createModel");
        let newModel = { planId: '', name: '', modelId: '', dataId: '', values: [], status: 'preliminary', ownerId: '' };
        let dialog = <Drawer variant="persistent" anchor="right" open={true} >
            <DataModelView appContext={this.props.appContext} model={newModel} onClose={this.onCloseDialog.bind(this)} />
        </Drawer>;
        this.setState({ progress: null, dialog: dialog });
    }

    render() {
        const { appContext, appContext: { state: { plan: { planId } } } } = this.props;
        const { filter, filtered, models, dialog, error, progress, dependencies } = this.state;
        const errors = this.props.appContext.stores.DataTypesStore.getErrors(`data_models`).errors;

        const columnData = [
            { id: 'modelId', width: 25, label: 'Valid', formatValue: (v) => {
                return errors[v] ? <Tooltip key='error' title={errors[v].join(', ')}><WarningIcon style={{ fill: 'red'}} /></Tooltip> : <ValidIcon key='valid' style={{ fill: 'green'}} />;
            }},
            { id: 'dataId', numeric: false, disabledPadding: false, label: 'Data ID' },
            { id: 'modelId', numeric: false, disabledPadding: false, label: 'Model ID' },
            { id: 'name', numeric: false, disabledPadding: false, label: 'Name' },
            { id: 'postDetect', numeric: false, disabledPadding: false, label: 'Post Detect', formatValue: (v) => { 
                return v === 'true' ? 'Yes' : 'No' } },
            { id: 'order', numeric: false, disabledPadding: false, label: 'Order' },
            { id: 'planId', numeric: false, disabledPadding: false, label: 'Plan ID', formatValue: (v) => {
                return <Plan appContext={this.props.appContext} planId={v} /> } }
        ];

        return (
            <table width="100%"><tbody>
                <tr>
                    <td>
                        <TextField style={styles.text} value={filter} label="Filter"
                            onChange={(e) => { this.setState({ filter }, this.updateFilter.bind(this)); }} />
                        <FormControlLabel style={{margin: 5}} control={<Checkbox checked={dependencies} onChange={(e) => {
                                this.setState({dependencies: e.target.checked}, this.loadContent.bind(this));
                                localStorage.setItem("DataModelsView.dependencies", `${e.target.checked}`);
                            }} />}label="Show Dependencies" />
                    </td>
                    <td align="right">
                        {error}
                        <EditableNote appContext={appContext} textId={`dataModelsTooling`} planId={planId} />
                        <IconButton disabled={progress !== null} onClick={this.loadContent.bind(this)}>{progress || <RefreshIcon />}</IconButton>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <EnhancedTable
                            disableMultiSelect={true}
                            onTable={table => this._types = table}
                            onSelected={this.selectModel.bind(this)}
                            onAdd={this.createModel.bind(this)}
                            orderBy='dataId'
                            columnData={columnData}
                            data={filtered ? filtered : models}
                            title='Data Models' />
                        {dialog}
                    </td>
                </tr>
            </tbody></table>
        );
    }
}

const styles = {
    text: {
        margin: 5,
        width: 500
    },
}

export default DataModelsView;
